import React, { memo, ReactNode } from 'react';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Badge from '@mui/material/Badge';
import { transformImageUrl } from 'presentations/assets';
import styled from '@emotion/styled';
import { background, white, whiteFix } from 'presentations/views/styles/color';

interface Props {
  src?: string | null;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
  children?: ReactNode;
  variant?: 'circular' | 'rounded' | 'square';
}

const Component = memo((props: Props) => {
  let src = undefined;
  if (props.src) {
    const options = { fill: 'crop' };
    src = transformImageUrl(props.src, options) || undefined;
  }
  return (
    <StyledAvatar
      className={props.className}
      alt={props.alt}
      src={src}
      style={props.style}
      variant={props.variant}
    >
      {props.children}
    </StyledAvatar>
  );
});

interface GroupProps {
  className?: string;
  max: number;
  children?: ReactNode;
  spacing?: number;
}
export const Group = (props: GroupProps) => {
  const max = props.max < 2 ? 2 : props.max;
  return (
    <StyledAvatarGroup
      className={props.className}
      max={max}
      spacing={props.spacing}
    >
      {props.children}
    </StyledAvatarGroup>
  );
};

interface BadgeProps {
  badgeContent?: ReactNode;
  children?: ReactNode;
}
export const AvatarBadge = (props: BadgeProps) => {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={props.badgeContent}
    >
      {props.children}
    </Badge>
  );
};

const StyledAvatarGroup = styled(AvatarGroup)`
  color: ${whiteFix};
  .MuiAvatar-root {
    img {
      background-color: ${background};
    }
  }
`;
const StyledAvatar = styled(Avatar)``;

export default Component;
